// This component list all different charts that a user can create
// It also handles
// 	- the differences in dropzones for each specific graphs along,
// 	- moving table fields into appropriate dropzones for each specific chart type

//Refactored this file to the below components present in ChartType Components
//useSwitchAxesUtils- ChartTypeComponents: handles all the changes in the icons
//ChartIcons generates all the icons
//ChartUtils consists of all the necessary function required by useSwitchAxesUtils
//ChartTypes imports all the necessary media for ChartIcons

import React, { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import './ChartIconStyles.css';
import './ChartOptions.css';
import { AnyAction } from 'redux';
import {
  canReUseData,
  changeChartTypeAndAxes,
  updateAxesQueryParam,
} from '../../redux/ChartPoperties/ChartPropertiesActions';
import {
  callQueryAPI,
  deleteSortConfiguration,
  updateChartData,
  updateFormatOption,
} from '../../redux/ChartPoperties/ChartControlsActions';
import { actionsToAddTileForRichText } from '../../redux/TabTile/TabTileActionsAndMultipleDispatches';
import ChartIcons from './ChartTypeComponents/ChartIcons';
import { useSwitchAxesForCharts } from './ChartTypeComponents/useSwitchAxesUtils';
import { RootState } from '../../redux';
import { ThunkDispatch } from 'redux-thunk';
import { addChartFilterTabTileName } from '../../redux/ChartFilterGroup/ChartFilterGroupStateActions';
import { enableOverrideForUIDAction } from '../../redux/ChartPoperties/ChartPropertiesActions';
import { checkMinRequiredCards } from '../ChartAxes/chartDataFunctions/checkMinRequiredCards';
import {
  handleCheckDisableField,
  applyMultiFieldSort,
  getFieldNamesByAxis,
  extractFieldsData,
  getFieldUidsByAxis,
} from './Sort/reusableFunctions';

//testing switch
const ChartTypes = ({
  //props
  propKey,
}: any) => {
  const { chartProp, tabState, tabTileProps, chartControls, chartGroup, checkedMeasure } =
    useSelector((state: RootState) => ({
      chartProp: state.chartProperties,
      tabState: state.tabState,
      tabTileProps: state.tabTileProps,
      chartControls: state.chartControls,
      chartGroup: state.chartFilterGroup,
      checkedMeasure:
        state.chartControls.properties[propKey].formatOptions.tooltipFormats.checkedMeasure,
    }));

  var selectedChart = chartProp.properties[propKey].chartType;
  const dispatch = useDispatch();
  const dispatch_thunk: ThunkDispatch<any, any, AnyAction> = useDispatch();
  const keepOldData = (propKey: string, reUseData: boolean) =>
    dispatch(canReUseData(propKey, reUseData));
  const updateChartDataChart = (propKey: string, chartData: string | any) =>
    dispatch(updateChartData(propKey, chartData));
  const switchAxesForCharts = useSwitchAxesForCharts(
    propKey,
    keepOldData,
    updateChartDataChart,
    hasChartData,
  );
  function hasChartData(propKey: string) {
    return (
      chartControls.properties[propKey].chartData &&
      chartControls.properties[propKey].chartData.length > 0
    );
  }

  const data: string | any =
    chartControls.properties[propKey].chartData.length > 0
      ? chartControls.properties[propKey].chartData
      : [];

  const showHide = chartControls.properties[propKey].showHide;
  const sortConfigurations = chartControls.properties[propKey].sortConfigurations || [];

  const clearOverRideOnChartChange = (newChart: string, oldChart: string, newChartAxes: any) => {
    let _isNewChart: boolean = [
      'multibar',
      'stackedBar',
      'horizontalBar',
      'horizontalStacked',
      'line',
      'area',
      'stackedArea',
      'pie',
      'donut',
      'rose',
      'waterfall',
      'wordCloud',
    ].includes(newChart);

    let _oldChart: boolean = [
      'multibar',
      'stackedBar',
      'horizontalBar',
      'horizontalStacked',
      'line',
      'area',
      'stackedArea',
      'pie',
      'donut',
      'rose',
      'waterfall',
      'wordCloud',
    ].includes(oldChart);

    if (!_isNewChart || !_oldChart) {
      let axes: any[] = newChartAxes.filter((axes: any) => axes.name !== 'Filter');

      [...axes].forEach((axis: any, _bIndex: number) => {
        [...axis.fields].forEach((field: any, idx: number) => {
          let _field = JSON.parse(JSON.stringify(field));
          _field.override = null;
          dispatch(updateAxesQueryParam(propKey, _bIndex + 1, idx, _field, 'chartAxes'));
          dispatch(enableOverrideForUIDAction(propKey, ''));
        });
      });
    }
  };
  //TODO:New Function for allowed numbers

  const addReportFilterGroup = (tempPropKey: string) => {
    let selectedFilterGroups = chartGroup.tabTile[tempPropKey] || [];
    let selectedDatasetID = chartProp.properties[tempPropKey]?.selectedDs?.id;

    if (!(selectedFilterGroups && selectedFilterGroups.length > 0)) {
      dispatch(addChartFilterTabTileName(selectedDatasetID, tempPropKey));
    }
  };

  const handleAddTile = async (chartName: string) => {
    let tabObj = tabState.tabs[tabTileProps.selectedTabId];

    await dispatch_thunk(
      actionsToAddTileForRichText({
        tabId: tabObj.tabId,
        nextTileId: tabObj.nextTileId,
        table: tabTileProps.selectedTable,
        selectedDs: chartProp.properties[propKey].selectedDs,
        selectedTablesInDs: chartProp.properties[propKey].selectedTable,
        fromTab: false,
        chartName: chartName,
      }),
    );

    addReportFilterGroup(`${tabObj.tabId}.${tabObj.nextTileId}`);
  };

  let chartAxes = chartProp.properties[propKey].chartAxes;

  const rowFieldNames = useMemo(
    () => getFieldNamesByAxis(chartAxes, 'Row'),
    [chartProp.properties[propKey].chartAxes],
  );

  const columnFieldNames = useMemo(
    () => getFieldNamesByAxis(chartAxes, 'Column'),
    [chartProp.properties[propKey].chartAxes],
  );

  const measureFieldUids = useMemo(
    () => getFieldUidsByAxis(chartAxes, 'Measure'),
    [chartProp.properties[propKey].chartAxes],
  );

  const dimensionFieldNames = useMemo(
    () => getFieldNamesByAxis(chartAxes, 'Dimension'),
    [chartProp.properties[propKey].chartAxes],
  );

  const splitByFieldNames = useMemo(
    () => getFieldNamesByAxis(chartAxes, 'Split By'),
    [chartProp.properties[propKey].chartAxes],
  );

  const rowFieldsData = useMemo(
    () => extractFieldsData(data, rowFieldNames),
    [data, rowFieldNames],
  );

  const columnFieldsData = useMemo(
    () => extractFieldsData(data, columnFieldNames),
    [data, columnFieldNames],
  );

  useEffect(() => {
    //update chart data according to configurations
    applyMultiFieldSort({
      data,
      sortConfigurations,
      chartControls,
      chartProperties: chartProp,
      propKey,
      showHide,
      dispatch,
      rowFieldsData,
      columnFieldsData,
      rowFieldNames,
      columnFieldNames,
      dimensionFieldNames,
      splitByFieldNames,
      measureFieldUids,
    });
  }, [chartProp.properties[propKey].chartType]);

  const updateCheckedMeasureListOnChartSwitch = (newChartAxes: any) => {
    let tempCheckedMeasure: string[] = [];
    const axes = newChartAxes || [];
    const measureAxes = axes.filter(
      (ax: any) => ax && (ax.name === 'Measure' || ax.name === 'X Axis' || ax.name === 'Y Axis'),
    );
    if (!measureAxes.length) return;

    const measureFields = measureAxes.flatMap((axis: any) => axis?.fields || []);

    const dimensionAxes = axes.filter(
      (ax: any) =>
        ax &&
        (ax.name === 'Row' ||
          ax.name === 'Column' ||
          ax.name === 'Dimension' ||
          ax.name === 'Date' ||
          ax.name === 'Split By'),
    );

    const dateFieldsFromDimensions = dimensionAxes.flatMap((axis: any) =>
      (axis?.fields || []).filter((field: any) => field.timeGrain === 'date'),
    );

    const derivedMeasureFields = [...measureFields, ...dateFieldsFromDimensions];
    if (!derivedMeasureFields.length) return;
    derivedMeasureFields.forEach((field: any) => {
      tempCheckedMeasure.push(field.uId);
    });
    dispatch(updateFormatOption(propKey, 'tooltipFormats', 'checkedMeasure', tempCheckedMeasure));
  };

  const getAndUpdateNewChartAxes = (oldChart: string, newChart: string) => {
    const { newChartAxes, callAPI = false } = switchAxesForCharts(oldChart, newChart) || {};
    dispatch_thunk(changeChartTypeAndAxes(propKey, newChart, newChartAxes));
    clearOverRideOnChartChange(oldChart, newChart, newChartAxes);

    if (oldChart !== newChart) {
      updateCheckedMeasureListOnChartSwitch(newChartAxes);
    }

    // Clear extra measures when switching to chart types that don't support them
    const chartsWithoutExtraMeasures = ['boxPlot', 'sankey', 'crossTab', 'table', 'simplecard'];
    if (chartsWithoutExtraMeasures.includes(newChart)) {
      dispatch(
        updateFormatOption(propKey, 'tooltipFormats', 'extraMeasureField', [
          { name: 'Measure', fields: [] },
        ] as any),
      );
      dispatch(updateFormatOption(propKey, 'tooltipFormats', 'extraMeasureFieldsResponses', []));
    }
    //--------------------- Remove sort configurations that are disabled for the new chart type(Start)-------------------//
    if (sortConfigurations.length > 0) {
      //create a temp chart prop which has updated chartaxes and chartType
      const tempChartPropForCheck = {
        ...chartProp,
        properties: {
          ...chartProp.properties,
          [propKey]: {
            ...chartProp.properties[propKey],
            chartAxes: newChartAxes,
            chartType: newChart,
          },
        },
      };

      // Check each sort configuration and remove if the field is now disabled
      let tempSortConfiguration = [...sortConfigurations];
      for (let i = tempSortConfiguration.length - 1; i >= 0; i--) {
        const config = tempSortConfiguration[i];
        const fieldExists = newChartAxes?.some((axis: any) =>
          axis.fields?.some((field: any) => field.uId === config.fieldId),
        );
        if (!fieldExists) {
          tempSortConfiguration.splice(i, 1);
          dispatch(deleteSortConfiguration(propKey, i));
        }

        const isDisabled = handleCheckDisableField(
          config.fieldId,
          propKey,
          tempChartPropForCheck,
          tempSortConfiguration,
        );

        if (config.sortOrder !== '' && isDisabled) {
          tempSortConfiguration.splice(i, 1);
          dispatch(deleteSortConfiguration(propKey, i));
        }
      }
    }
    //---------------------------------------(End)-------------------------------------------------

    const tempChartProp = {
      chartAxes: newChartAxes,
      chartType: newChart,
    };
    const minReqMet = checkMinRequiredCards(tempChartProp, newChart);

    if (!minReqMet) {
      dispatch(updateChartData(propKey, ''));
    }

    if (callAPI || !hasChartData(propKey)) {
      dispatch(callQueryAPI(propKey, true));
    }
  };

  return (
    <React.Fragment>
      <div className="chartIconsContainer">
        <ChartIcons
          selectedChart={selectedChart}
          propKey={propKey}
          chartProp={chartProp}
          chartControls={chartControls}
          getAndUpdateNewChartAxes={getAndUpdateNewChartAxes}
          handleAddTile={handleAddTile}
        />
      </div>
    </React.Fragment>
  );
};

export default ChartTypes;
